import styled from '@emotion/styled';
import { Divider } from '@mui/material';

export const NormalDivider = styled(Divider)({
  borderStyle: 'solid',
  background: 'rgba(255, 255, 255, 0.15)',
  borderColor: 'rgba(255, 255, 255, 0.15)',
});

export const WideNormalDivider = styled(Divider)({
  position: 'relative',
  left: -100,
  width: '200%',
  borderWidth: '0.25px',
});

export const FullWidthDivider = styled(Divider, {
  shouldForwardProp: prop => prop !== 'offsetPadding',
})<{ offsetPadding: number }>(({ offsetPadding }) => ({
  position: 'relative',
  left: `-${offsetPadding}px`,
  width: `calc(100% + ${offsetPadding * 2}px)`,
}));

export const FormDivider = styled(Divider)({
  borderStyle: 'dashed',
  margin: '0.6rem 0 0.6rem 0',
});

export const FormInputH6 = styled('h6')({
  padding: '0 0.5rem 0 0',
});
